//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[[0,"Filename",1,0],[0,"NetsFilterString",1,0],[0,"NetsFilterStringEnabled",1,0],[0,"ShowLog",1,0]],[[[],"QueryEntities",{},0,0],[["count"],"GetLayerNames",{R_:{names:""}},0,0],[["name"],"GetLayerImported",{R_:{importOption:''}},1,0],[["name","importOption"],"SetLayerImported",{},2,0],[["importOption"],"SetAllLayersImported",{},1,0],[["count"],"GetNetNames",{R_:{names:""}},0,0],[["name"],"GetNetImported",{R_:{importOption:''}},1,0],[["name","importOption"],"SetNetImported",{},2,0],[["count"],"GetPadstackNames",{R_:{names:""}},0,0],[["name"],"GetPadstackImported",{R_:{importOption:''}},1,0],[["name","importOption"],"SetPadstackImported",{},2,0],[["name"],"GetPadstackPart",{R_:{part:''}},1,0],[["name","part"],"SetPadstackPart",{},2,0]],[]];
SPLM.PcbExchange.ExternalDataImportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.ExternalDataImportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.ExternalDataImportBuilder.JaPcbExternalDataImportBuilderImportoption = Object.freeze({
    "Import" : "Import", "DoNotImport" : "DoNotImport"});

export default SPLM;